import React, { useEffect, useState } from "react";
import "./styles.css";
import SideMenu from "../../Elements/SideMenu";
import Breadcrumb from "../../Elements/Breadcrumb";
import Accordion from "../../Elements/Accordion";
import down from "../../../Assets/Icons/icon_down_arrow.png";
import Timeline from "../../Elements/Timeline";
import { usePatientContext } from "../../../Context/PatientContext";
import { useParams } from "react-router-dom";
import Chart from "chart.js/auto";
import { CategoryScale } from "chart.js";
import LineChart from "../../Elements/Charts/LineChart";
import {
  getClinicalParams,
  getPatientById,
  getPatientTimeline,
} from "../../../Services";
import { useAuth } from "../../../Context/AuthContext";
import { getDDMMYY } from "../../../Helpers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

Chart.register(CategoryScale);

const duration = [
  { id: 1, name: "Today" },
  { id: 2, name: "Weekly" },
  { id: 3, name: "Monthly" },
  { id: 4, name: "Quarterly" },
  { id: 5, name: "6 Months" },
  { id: 6, name: "Yearly" },
];

const calendarCustomStyle = {
  ".MuiDateCalendar-root": {
    height: "100%",
    fontSize: "10px",
  },
  ".MuiDateCalendar-root button": {
    fontSize: "14px",
    padding: 0,
    margin: 0,
  },
  ".MuiDateCalendar-root .MuiPickersCalendarHeader-label": {
    fontSize: "14px",
    padding: 0,
    margin: 0,
  },
};

const ClinicalParameters = () => {
  const {
    patientDetails,
    patientTimeline,
    updatePatientDetails,
    updatePatientTimeline,
  } = usePatientContext();
  const { patientId } = useParams(); /* Read dynamic URL params */
  const { physician } = useAuth();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [currentDuration, setCurrentDuration] = useState(null);
  const [completeTimeline, setCompleteTimeline] = useState([]);
  const [clinicalParams, setClinicalParams] = useState([]);
  const [selectedParams, setSelectedParams] = useState([]);
  const [chartsData, setChartsData] = useState([]);
  const [applyFilter, setApplyFilter] = useState(false);
  const [filterDates, setFilterDates] = useState({
    startMonth: null,
    endMonth: null,
    startYear: null,
    endYear: null,
  });

  const getPatientDetails = async () => {
    try {
      const detailsResponse = await getPatientById(
        physician.physician._id,
        patientId
      );
      const timelineResponse = await getPatientTimeline(
        physician.physician._id,
        patientId
      );
      const clinicalParamsResponse = await getClinicalParams(
        physician.physician._id
      );
      if (!detailsResponse.error) updatePatientDetails(detailsResponse.data);
      if (!timelineResponse.error) {
        updatePatientTimeline(timelineResponse.data);
        setCompleteTimeline(timelineResponse.data);
      }
      if (!clinicalParamsResponse.error)
        setClinicalParams(clinicalParamsResponse.data);
    } catch (error) {
      console.error("Error fetching patient details:", error);
    }
  };

  /**
   * Function to apply duration filter
   * @param {*} list - to be filtered list
   * @returns - returns applied filters on list
   */
  const handleMonthFilter = (list) => {
    let temp = [];

    temp = list.filter((item) => {
      return (
        (!filterDates.startMonth ||
          // new Date(item.reportDate) >=
          new Date(
            new Date(item.date || item.startDate || item.endDate).getFullYear(),
            new Date(item.date || item.startDate || item.endDate).getMonth()
          ) >=
            new Date(
              filterDates.startMonth.year(),
              filterDates.startMonth.month()
            )) &&
        (!filterDates.endMonth ||
          new Date(
            new Date(item.date || item.endDate || item.startDate).getFullYear(),
            new Date(item.date || item.endDate || item.startDate).getMonth()
          ) <=
            // new Date(item.reportDate) <=
            new Date(filterDates.endMonth.year(), filterDates.endMonth.month()))
      );
    });

    return temp;
  };

  const handleApplyFilter = () => {
    // apply only if both start sate and end date is selected
    if (filterDates.startMonth && filterDates.endMonth) {
      // console.log("both dates");
      updatePatientTimeline(handleMonthFilter(completeTimeline));
    } else {
      alert("Enter both dates");
    }
  };

  useEffect(() => {
    getPatientDetails();
  }, []);

  useEffect(() => {
    // get details from patientDetails
    setChartsData(
      selectedParams.map((param) => {
        return {
          title: param.name,
          data: {
            labels: patientDetails["clinicalParams"][param.reportType].reduce(
              (acc, p) => {
                // filter according to parameter and duration filter
                p[param.schemaVariable] &&
                  (!filterDates.startMonth ||
                    new Date(
                      new Date(p["date"]).getFullYear(),
                      new Date(p["date"]).getMonth()
                    ) >=
                      new Date(
                        filterDates.startMonth.year(),
                        filterDates.startMonth.month()
                      )) &&
                  (!filterDates.endMonth ||
                    new Date(
                      new Date(p["date"]).getFullYear(),
                      new Date(p["date"]).getMonth()
                    ) <=
                      // new Date(item.reportDate) <=
                      new Date(
                        filterDates.endMonth.year(),
                        filterDates.endMonth.month()
                      )) &&
                  acc.push(getDDMMYY(p["date"]));
                return acc;
              },
              []
            ),
            datasets: [
              {
                label: param.name,
                data: patientDetails["clinicalParams"][param.reportType].reduce(
                  (acc, p) => {
                    p[param.schemaVariable] &&
                      (!filterDates.startMonth ||
                        new Date(
                          new Date(p["date"]).getFullYear(),
                          new Date(p["date"]).getMonth()
                        ) >=
                          new Date(
                            filterDates.startMonth.year(),
                            filterDates.startMonth.month()
                          )) &&
                      (!filterDates.endMonth ||
                        new Date(
                          new Date(p["date"]).getFullYear(),
                          new Date(p["date"]).getMonth()
                        ) <=
                          // new Date(item.reportDate) <=
                          new Date(
                            filterDates.endMonth.year(),
                            filterDates.endMonth.month()
                          )) &&
                      acc.push(p[param.schemaVariable]["value"]);
                    return acc;
                  },
                  []
                ),
              },
            ],
          },
        };
      })
    );
  }, [selectedParams, applyFilter]);

  return (
    <div className="container">
      <SideMenu />
      <div className="clinical-parameters-trends-frame">
        <Breadcrumb
          contents={[
            { name: "Dashboard", url: "/dashboard" },
            {
              name: `${patientDetails.firstName} ${patientDetails.lastName}`,
              url: `/patient/${patientId}`,
            },
            { name: "Clinical Parameters" },
          ]}
        />
        <div className="page-title">
          <h1 className="h1-400 blue">Clinical Parameters</h1>
          <div className="dropdown-container">
            <div
              className="dropdown-title-box"
              onClick={() => setDropdownOpen((value) => !value)}
            >
              <p className="medium-grey body1">
                {currentDuration ? currentDuration.name : "Choose Duration"}
              </p>
              <img src={down} />
            </div>
            {/* dropdown menu */}
            {dropdownOpen && (
              <div className="duration-dropdown">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={filterDates.startMonth}
                    onChange={(value) => {
                      setFilterDates({
                        ...filterDates,
                        ["startMonth"]: value,
                      });
                    }}
                    label="From"
                    sx={{
                      width: "12rem",
                    }}
                    views={["month", "year"]}
                    slotProps={{
                      textField: { size: "small" },
                      popper: {
                        sx: calendarCustomStyle,
                      },
                    }}
                    monthsPerRow={4}
                  />
                </LocalizationProvider>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={filterDates.endMonth}
                    onChange={(value) => {
                      setFilterDates({
                        ...filterDates,
                        ["endMonth"]: value,
                      });
                    }}
                    label="To"
                    sx={{ width: "12rem" }}
                    views={["month", "year"]}
                    slotProps={{
                      textField: { size: "small" },
                      popper: {
                        sx: calendarCustomStyle,
                      },
                    }}
                    monthsPerRow={4}
                  />
                </LocalizationProvider>
                <div>
                  <button
                    id="clear-button"
                    onClick={() => {
                      setApplyFilter(true);
                      handleApplyFilter();
                    }}
                  >
                    Apply
                  </button>
                  <button
                    id="clear-button"
                    onClick={() => {
                      setApplyFilter(false);
                      setFilterDates({
                        startMonth: null,
                        endMonth: null,
                        startYear: null,
                        endYear: null,
                      });
                      updatePatientTimeline(completeTimeline);
                    }}
                  >
                    Clear
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="main-content">
          <div className="parameters-container">
            {clinicalParams.map((item, index) => (
              <Accordion
                // array={item.parameters.map((param) => param.name)}
                array={item.parameters.map((param) => ({
                  ...param,
                  reportType: item.reportType.schemaVariable,
                }))}
                // array={item.parameters}
                text={item.reportType.name}
                key={index}
                style={{ width: "85%" }}
                listType="checkbox"
                checkedItems={selectedParams}
                setCheckedItems={setSelectedParams}
              />
            ))}
          </div>
          <div className="mid-charts-container">
            {chartsData.map((data) => (
              <div>
                <LineChart chartData={data.data} title={data.title} />
              </div>
            ))}
          </div>
          <div className="right-timeline-container">
            <Timeline view="expanded" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClinicalParameters;
